import Axios from "axios";
import cloneDeep from "lodash/cloneDeep";

import { getUrl } from "../Config";
import {
  settingFromUrl,
  updateContractSentinal,
} from "../../../configs/settingsFromUrl";
// import { updateContractSentinal } from "./Config/settingFromUrl";

import { store } from "../../../redux/storeConfig/store";
import {
  getDecryptedItem,
  setEncryptedItem,
} from "../../../utility/encryptedStorage";
import alertCall from "../../../components/@self/CustomAlert";

const CONFIG = getUrl();
const CORS_WORKAROUND = ""; //'https://cors-anywhere.herokuapp.com/';

const CLOUDHUB_BASE_URL = CONFIG.URL.AUTH0.CLOUDHUB_AUTH;
const CONTRACT_SENTINEL_BASE_URL = CONFIG.URL.AUTH0.CONTRACT_SENTINEL_AUTH;
const AZURE_BLOB_URL = CONFIG.URL.AZURE_BLOB.BASE_URL;

///////////////////////////////////
const getHeaderData = (customOptionsObj = {}) => {
  const customOptions = customOptionsObj || {};

  const userData = JSON.parse(getDecryptedItem("data"));
  const headers = {};

  if (userData) {
    const { id: userId, organisationId } = userData;

    if (userId) {
      headers.user_id = userId || "";
    }
    if (organisationId) {
      headers.user_org = organisationId;
    }
  }

  const token = getDecryptedItem("token");
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return {
    ...customOptions,
    headers: {
      ...headers,
      ...cloneDeep(customOptions.headers || {}),
    },
  };
};

function get(url, customOptionsObj) {
  if (!url) {
    console.error("URL is a mandatory field to make an API call");
    return;
  }

  const head_data = getHeaderData(customOptionsObj);

  return new Promise((resolve, reject) => {
    Axios.get(url, head_data).then(
      (data) => {
        resolve(data);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

function post(url, param, customOptionsObj) {
  if (!url) {
    console.error("URL is a mandatory field to make an API call");
    return;
  }

  const head_data = getHeaderData(customOptionsObj);

  return new Promise((resolve, reject) => {
    Axios.post(url, param, head_data).then(
      (resp) => {
        resolve(resp);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

function put(url, param) {
  if (!url) {
    console.error("URL is a mandatory field to make an API call");
    return;
  }

  const head_data = getHeaderData();

  return new Promise((resolve, reject) => {
    Axios.put(url, param, head_data).then(
      (resp) => {
        resolve(resp);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

function deleteApi(url, param, customOptionsObj) {
  if (!url) {
    console.error("URL is a mandatory field to make an API call");
    return;
  }

  const head_data = getHeaderData(customOptionsObj);

  return new Promise((resolve, reject) => {
    Axios.delete(url, { ...head_data, data: param }).then(
      (resp) => {
        resolve(resp);
      },
      (e) => {
        reject(e);
      },
    );
  });
}
///////////////////////////////////

/**
 * ***************************************************
 */

/**
 * APIs related to the user Login & User Details goes here
 */

function userLoginCloudhub(data) {
  let url = CORS_WORKAROUND + CONFIG.URL.LOGIN.CLOUDHUB_LOGIN;
  return new Promise((res, rej) => {
    post(url, data).then(
      (resp) => {
        res(resp.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function userLoginContractSentinel(data) {
  let url = CORS_WORKAROUND + CONFIG.URL.LOGIN.CONTRACT_SENTINEL_LOGIN;
  return new Promise((res, rej) => {
    post(url, data).then(
      (resp) => {
        res(resp.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

/**
 * looking for the id of contract management id
 */
function getContractManagement() {
  return new Promise((resolve, reject) => {
    getCollection().then((resp) => {
      console.log(resp);
      resolve(resp);
    });
  });
}

function getCustomCall(url) {
  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        let data = resp.data;
        console.log(data);
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getCollections() {
  let url = CORS_WORKAROUND + CONFIG.URL.COLLECTIONS.GET;
  return new Promise((res, rej) => {
    get(url).then(
      (response) => {
        const { status, data } = response?.data || {};
        let workqueuesData = [];

        if (status && data) {
          workqueuesData = cloneDeep(data);
        }

        if (settingFromUrl("contract_sentinal")) {
          updateContractSentinal(workqueuesData);
        }
        res(workqueuesData);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getModels() {
  let url = CORS_WORKAROUND + CONFIG.URL.MODEL.GET;
  return new Promise((res, rej) => {
    get(url).then(
      (response) => {
        const { status, data, errorMessage, jsonData } = response?.data || {};
        if (status && data) {
          res(data);
        }
        const errMsg =
          errorMessage ||
          jsonData ||
          "Unable to fetch models, please try again.";
        rej(errMsg);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

/**
 * responsible for getting a single collection
 */
function getCollection(collectionId) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.GET_ALL;
  url = url.replace("$id", collectionId);
  return new Promise((res, rej) => {
    get(url).then(
      (response) => {
        const { status, data, errorMessage, jsonData } = response?.data || {};
        if (status && data) {
          res(data);
        }

        const errMsg =
          errorMessage ||
          jsonData ||
          "Unable to fetch workqueue details, please try again.";
        rej(errMsg);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getDocuments(id, param) {
  if (settingFromUrl("contract_sentinal")) {
    //removing 'contract_sentinal' from id
    id = id.replace("contract_sentinal", "");
  }
  param = param || "";
  // let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENTS.GET + param;
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.GET_ALL;
  url = url.replace("$id", id);
  return new Promise((resolve, reject) => {
    get(url).then(
      (response) => {
        const { status, data, errorMessage, jsonData } = response?.data || {};

        if (status && data) {
          resolve(data);
        }

        const errMsg =
          errorMessage ||
          jsonData ||
          "Unable to fetch documents, please try again.";
        reject(errMsg);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

function getEntities(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.ENTITIES.GET;
  url = url.replace("$cid", cid).replace("$did", did);
  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        let data = resp.data;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getEntitiesToken(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.BASE_URL + "/" + did;
  url = url.replace("$cid", cid).replace("$did", did);
  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function fetchtBoundingBoxData(
  cid,
  did,
  imagePath,
  width,
  height,
  x1,
  y1,
  x2,
  y2,
) {
  console.log(arguments);
  let url = CORS_WORKAROUND + CONFIG.URL.BOUNDING_BOX_CREATE_DATA.GET;
  url = url
    .replace("$cid", cid)
    .replace("$did", did)
    .replace("$image", imagePath)
    .replace("$width", width)
    .replace("$height", height)
    .replace("$x1", Math.round(x1))
    .replace("$y1", Math.round(y1))
    .replace("$x2", Math.round(x2))
    .replace("$y2", Math.round(y2));

  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getBoundingBox(did) {
  let url = CORS_WORKAROUND + CONFIG.URL.BOUNDING_BOX.GET;
  url = url.replace("$did", did);

  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getDocument(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.BASE_URL + "/" + did;
  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        let data = resp.data;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

const getSimilarDocuments = (did) => {
  const url = (CORS_WORKAROUND + CONFIG.URL.DOCUMENT.SIMILAR_DOCUMENTS).replace(
    "$did",
    did,
  );

  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp?.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
};

const getDocumentStructure = (cid, did) => {
  const url = (CORS_WORKAROUND + CONFIG.URL.DOCUMENT.STRUCTURE)
    .replace("$cid", cid)
    .replace("$did", did);

  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp?.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
};

const getSimilarClauses = (cid, did, index) => {
  const url = (CORS_WORKAROUND + CONFIG.URL.DOCUMENT.SIMILAR_CLAUSES)
    .replace("$cid", cid)
    .replace("$did", did)
    .replace("$index", index);

  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        res(resp?.data);
      },
      (e) => {
        rej(e);
      },
    );
  });
};

const donwloadFileFromAzureBlobStorage = (fileId, fileName) => {
  let url = AZURE_BLOB_URL + `/download/${fileId}`;

  return get(url, { responseType: "blob" }).then(
    (response) => {
      console.log("donwloadFileFromAzureBlobStorage response", response);
      const { data, headers } = response;
      const dataType = headers["content-type"];

      let downloadLink = document.createElement("a");
      const blob = new Blob([data], {
        type: dataType || "application/octet-stream",
      });
      downloadLink.href = window.URL.createObjectURL(blob);
      if (fileName) {
        downloadLink.setAttribute("download", fileName);
      }
      document.body.appendChild(downloadLink);
      downloadLink.click();

      setTimeout(() => {
        URL.revokeObjectURL(downloadLink.href);
        downloadLink.parentNode.removeChild(downloadLink);
      }, 0);
    },
    (e) => {
      console.log("donwloadFileFromAzureBlobStorage error", e);
      throw e;
    },
  );
};

function getSearchableDocument(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.DOWNLOAD + "?type=search";
  url = url.replace("$cid", cid).replace("$did", did);

  return new Promise((res, rej) => {
    get(url, { responseType: "blob" }).then(
      (resp) => {
        res(resp);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getMappings(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.MAPPINGS.GET;
  url = url.replace("$cid", cid).replace("$did", did);
  return new Promise((res, rej) => {
    get(url).then(
      (resp) => {
        let data = resp.data;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function getGroups(id) {
  let url = CORS_WORKAROUND + CONFIG.URL.GROUPS.GET;
  url = url.replace("$id", id);

  return new Promise((res, rej) => {
    get(url).then(
      (response) => {
        const { status, data, errorMessage, jsonData } = response?.data || {};
        if (status && data) {
          res(data);
        }

        const errMsg =
          errorMessage ||
          jsonData ||
          "Unable to fetch workqueue details, please try again.";
        rej(errMsg);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function uploadDoc(cid, groupName, fileData) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.POST;
  if (groupName) {
    url += "?group=" + groupName;
  }
  url = url.replace("$cid", cid);

  return new Promise((res, rej) => {
    post(url, fileData).then(
      (resp) => {
        let data = resp.data;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function updateEntities(did, param, version) {
  let url = CORS_WORKAROUND + CONFIG.URL.ENTITIES.PUT + "?version=" + version;

  url = url.replace("$did", did);
  return new Promise((res, rej) => {
    put(url, param).then(
      (response) => {
        if (response?.data?.status) {
          alertCall(
            response?.data?.jsonData || "Detail updated successfully!",
            "success",
          );
        } else {
          alertCall(response?.data?.errorMessage, "danger");
        }

        let data = response.data;
        res(data);
      },
      (e) => {
        alertCall("Something went wrong", "danger");
        rej(e);
      },
    );
  });
}

function updateMappings(cid, did, type, param, headerParam) {
  let url = CORS_WORKAROUND + CONFIG.URL.MAPPINGS.POST;
  url = url.replace("$cid", cid).replace("$did", did);
  url += `?mode=${type || "save"}`;

  return new Promise((res, rej) => {
    post(url, param, {
      headers: headerParam,
      validateStatus: (status) => status >= 200,
    }).then(
      ({ data, status }) => {
        if (status === 200) {
          res(data.message);
        } else {
          rej(data.message);
        }
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function deleteDocument(cid, did) {
  let url = CORS_WORKAROUND + CONFIG.URL.DOCUMENT.DELETE;
  url = url.replace("$cid", cid).replace("$did", did);
  return new Promise((res, rej) => {
    deleteApi(url).then(
      (resp) => {
        let data = resp.data;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
}

function deleteAllDocuments(cid) {
  if (cid) {
    let url = CORS_WORKAROUND + CONFIG.URL.COLLECTIONS.DELETE;
    url = url.replace("$cid", cid) + "?mode=clean";

    return new Promise((res, rej) => {
      deleteApi(url).then(
        (resp) => {
          let data = resp.data;
          res(data);
        },
        (e) => {
          rej(e);
        },
      );
    });
  }
}

/**
 * responsible for exporting File (Import Export)
 */

function exportFile(data) {
  let url = CORS_WORKAROUND + CONFIG.URL.IMPORTEXPORT.POST;
  return new Promise((resolve, reject) => {
    post(url, data).then(
      (response) => {
        resolve(response.data);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

function logOut() {
  store.dispatch({ type: "USER_LOGOUT" });
  const themeConfig = getDecryptedItem("themeConfig");
  sessionStorage.clear();
  localStorage.clear();
  setEncryptedItem("themeConfig", themeConfig);

  window.location.href = "/login";
}

const forceLogOut = () => {
  logOut();
  setTimeout(() => {
    window.location.reload(true);
  }, 500);
};

const getCloudhubUserInfoFromAuth0Token = (token) => {
  const url = `${CLOUDHUB_BASE_URL}/api/token/userInfo`;
  return new Promise((res, rej) => {
    get(url, { headers: { token } }).then(
      (resp) => {
        const { data } = resp;
        res(data);
      },
      (e) => {
        rej(e);
      },
    );
  });
};

export {
  get,
  post,
  put,
  deleteApi,
  getCollections,
  getModels,
  getContractManagement,
  getCollection,
  getDocuments,
  getDocument,
  getSimilarDocuments,
  getDocumentStructure,
  getSimilarClauses,
  donwloadFileFromAzureBlobStorage,
  getSearchableDocument,
  getEntities,
  getMappings,
  uploadDoc,
  updateEntities,
  updateMappings,
  deleteDocument,
  deleteAllDocuments,
  getGroups,
  getEntitiesToken,
  userLoginCloudhub,
  exportFile,
  getBoundingBox,
  getCustomCall,
  fetchtBoundingBoxData,
  logOut,
  forceLogOut,
  getCloudhubUserInfoFromAuth0Token,
  userLoginContractSentinel,
};
